/* eslint-disable */
export enum FinnairConfirmationStatus {
  OK = 'OK',
  PROCESSING = 'PROCESSING',
  ERROR = 'ERROR'
}

